import API from '../AxiosInstance';
import { executeChunkedRequests, BackendLimits } from '@/components/utils/request-chunking';

export default {
  listNodes: function (rootNodeId) {
    return API.get(`recycle-bin/${rootNodeId}`, {});
  },

  restorePods: async function (rootNodeId, podIds) {
    const result = await executeChunkedRequests({
      items: podIds,
      chunkSize: BackendLimits.MAX_PODS_PER_RESTORE,
      requestFn: (chunk) => API.post(`recycle-bin/${rootNodeId}/restore`, { podids: chunk }),
      errorStrategy: { stopOnError: true },
    });

    if (!result.success && !result.partialSuccess) {
      throw result.errors[0]?.error;
    }
    return result.data;
  },

  permanentlyDeletePods: async function (rootNodeId, podIds) {
    const result = await executeChunkedRequests({
      items: podIds,
      chunkSize: BackendLimits.MAX_PODS_PER_DELETE,
      requestFn: (chunk) => API.post(`recycle-bin/${rootNodeId}/delete`, { podids: chunk }),
      errorStrategy: { stopOnError: true },
    });

    if (!result.success && !result.partialSuccess) {
      throw result.errors[0]?.error;
    }
    return result.data;
  },

  emptyRecycleBin: function (rootNodeId) {
    return API.post(`recycle-bin/${rootNodeId}/empty`, {});
  },
};
